/************
 * Developed by : Shiva Software Solutions
 * File Name : Patient.js
 * Date : 23-06-2021
 * Descriptions : Call api response using reducers
 ************/
import {
  PATIENT_VITAL_HISTORY_DATA,
  PATIENT_VITAL_HISTORY_DATA_COUNT,
  VITAL_DATA_NOT_FOUND,
  VITAL_PDF_DATA,
  PATIENT_VITAL_PATIENTS,
  COVID_DATA_HTML,
  COVID_DATA_HTML_NO_DATA,
} from '../../shared/constants/ActionTypes';

const initialState = {
  patientvitallist: [],
  patientvitalcount: 0,
  errordata: '',
  vitalsdata: '',
  vitalpatients: [],
  covid_datas: [],
  covid_no_datas: '',
};
const covidVitalReducer = (state = initialState, action) => {
  switch (action.type) {
    //Assign user data
    case PATIENT_VITAL_HISTORY_DATA:
      return {
        ...state,
        patientvitallist: action.payload,
      };
    case PATIENT_VITAL_HISTORY_DATA_COUNT:
      return {
        ...state,
        patientvitalcount: action.payload,
      };
    //Get vital history
    case VITAL_PDF_DATA:
      return {
        ...state,
        vitalsdata: action.payload,
      };
    //Get vital error
    case VITAL_DATA_NOT_FOUND:
      return {
        ...state,
        errordata: action.payload,
      };
    case PATIENT_VITAL_PATIENTS:
      return {
        ...state,
        vitalpatients: action.payload,
      };
    //GEt covid data
    case COVID_DATA_HTML:
      return {
        ...state,
        covid_datas: action.payload,
      };
    //GEt covid error
    case COVID_DATA_HTML_NO_DATA:
      return {
        ...state,
        covid_no_datas: action.payload,
      };

    default:
      return state;
  }
};
export default covidVitalReducer;
